import { useAuthStore } from "@/store/auth";
import { useEffect, useState } from "react";

// 游客模式：这里只等待持久化登录态恢复，不再因未登录自动弹窗或阻断页面访问。
export function useAuthRedirect(): { hydrated: boolean; authorized: boolean } {
    const [ hasHydrated, setHasHydrated ] = useState( false );

    useEffect( () => {
        // 等待 zustand 持久化状态恢复，避免因为初始 token 为空产生误跳转
        const persist = useAuthStore.persist;
        const unsubscribeHydration = persist?.onFinishHydration?.( () => setHasHydrated( true ) );

        if ( persist?.hasHydrated?.() ) {
            setHasHydrated( true );
        } else if ( !persist ) {
            setHasHydrated( true );
        }

        return () => {
            unsubscribeHydration?.();
        };
    }, [] );

    return { hydrated: hasHydrated, authorized: hasHydrated };
}
